import React, { Component } from 'react';
import moment from 'moment';
import { Form, Row, Col, Input, Select, Spin, DatePicker, Typography, Checkbox } from 'antd';
const { Text } = Typography;

export default class EditWorkExperience extends Component {
  render() {
    const { 
      formRef, 
      getCity,
      isDate,
      current, 
      onSubmitEdit, 
      onFocusCity, 
      onSearchCity, 
      handleChecked,
      onChangeEndDate,
      onChangeStartDate,
      dataWorkExperience
    } = this.props;

    return (
      <React.Fragment>
        <Form ref={formRef} onFinish={onSubmitEdit} layout="vertical">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item 
                label="Title"
                name="title"
                validateFirst
                initialValue={dataWorkExperience.title ? dataWorkExperience.title : null }
                rules={[
                  { max: 50, message: '50 characters only' },
                  { required: true, message: 'This is a required field' },
                  { min: 5, message: 'Title must be at least 5 characters' },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item 
                label="Employment Type" 
                name="employmentType"
                rules={[
                  { required: true, message: 'This is a required field' },
                ]}
                initialValue={dataWorkExperience.employmentType ? dataWorkExperience.employmentType : null }
              >
                <Select>
                  <Select.Option key="1" value="FULL_TIME">Full Time</Select.Option>
                  <Select.Option key="2" value="PART_TIME">Part Time</Select.Option>
                  <Select.Option key="3" value="FREELANCE">Freelance</Select.Option>
                  <Select.Option key="4" value="INTERNSHIP">Internship</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item 
                label="Company"
                name="company"
                validateFirst
                initialValue={dataWorkExperience.company ? dataWorkExperience.company : null }
                rules={[
                  { max: 50, message: '50 characters only' },
                  { required: true, message: 'This is a required field' },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item 
                label="City" 
                name="cityId"
                initialValue={dataWorkExperience.cityId ? dataWorkExperience.cityId : null }
                rules={[
                  { required: true, message: 'This is a required field' },
                ]}
              >
                <Select
                  showSearch
                  filterOption={false}
                  placeholder="type a city"
                  onFocus={onFocusCity}
                  onSearch={onSearchCity}
                  loading={getCity.loading}
                  notFoundContent={getCity.loading ? <Spin size="small" /> : null}
                >
                  {
                    getCity.data && getCity.data.map(item => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.name}, {item.countryName}
                      </Select.Option>
                    ))
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item 
                label="Start Date" 
                name="startDate"
                rules={[
                  { required: true, message: 'This is a required field' },
                ]}
                initialValue={dataWorkExperience.startDate ? moment(dataWorkExperience.startDate, 'YYYY-MM') : null }
              >
                <DatePicker 
                  picker="month" 
                  placeholder="YYYY-MM" 
                  style={{ width: '100%' }}
                  onChange={onChangeStartDate} 
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item 
                label="End Date" 
                name="endDate"
                rules={[
                  { required: !current, message: 'This is a required field' },
                ]}
                validateStatus={isDate && !current ? "error" : null}
                help={isDate && !current ? "Your end date can't be earlier than your start date" : null}
                initialValue={dataWorkExperience.endDate ? moment(dataWorkExperience.endDate, 'YYYY-MM'): null }
              >
                {
                  current ?
                  <Text className="fs-12" type="secondary">Present</Text>
                  :
                  <DatePicker 
                    picker="month" 
                    placeholder="YYYY-MM" 
                    style={{ width: '100%' }}
                    onChange={onChangeEndDate} 
                  />
                }
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label=" " name="current">
                <Checkbox onChange={handleChecked} checked={current}>I'm currently working in this role</Checkbox>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item 
                label="Job Description"
                name="jobDescription"
                validateFirst
                initialValue={dataWorkExperience.jobDescription ? dataWorkExperience.jobDescription : null }
                rules={[
                  { max: 200, message: '200 characters only' },
                ]}
              >
                <Input.TextArea rows={3} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </React.Fragment>
    )
  }
}
